import React from "react";
import { StudentReportUIProvider } from "./StudentReportUIContext";
import { StudentReportCard } from "./StudentReportCard";

export function StudentReportPage() {
  return (
    <StudentReportUIProvider>
      <StudentReportCard />
    </StudentReportUIProvider>
  );
}